import React, { useRef, useState } from "react"

interface Layout {
  left?: number
  top?: number
  right?: number
  bottom?: number
}

type DraggableComponentProps = Layout & {
  children: React.ReactNode
}

const Draggable: React.FC<DraggableComponentProps> = (props) => {
  const { children, left, right, top, bottom } = props
  const [isDragging, setIsDragging] = useState(false)
  const [layout, setLayout] = useState<Layout>({ left, right, top, bottom })
  const draggableRef = useRef<HTMLDivElement>(null)
  const offset = useRef({ x: 0, y: 0 })

  const handleMouseDown = (event: React.MouseEvent) => {
    if (draggableRef.current) {
      const rect = draggableRef.current.getBoundingClientRect()
      offset.current = {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      }
      setIsDragging(true)
    }
  }

  const handleMouseMove = (event: React.MouseEvent) => {
    if (isDragging) {
      setLayout({
        left: event.clientX - offset.current.x,
        top: event.clientY - offset.current.y,
      })
    }
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }

  const handleMouseLeave = () => {
    setIsDragging(false)
  }

  return (
    <div
      ref={draggableRef}
      style={{
        position: "fixed",
        cursor: isDragging ? "grabbing" : "grab",
        ...layout,
      }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  )
}

export default Draggable
